import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '../auth/session';

export const Route = createFileRoute('/contests/$id')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: Outlet,
});
